import { get } from '@/api/request'
import { PaginationParams, PaginationResponse } from '@/api/base'

// 日历事件接口
export interface CalendarEvent {
  id: number
  title: string
  description: string
  startTime: string
  endTime: string
  activityType: number
  tags: string[]
  location?: string
  brand?: string
  link?: string
  content: string
}
export interface EventRequest {
  order?: string
  orderBy?: string
  startTimeStart?: string
  startTimeEnd?: string
  activityType?: number
  tags?: string
}

export interface EventTag {
  id: number
  name: string
  category: string
  color: string
  description: string
  status: number
  createdTime: string
}

// 获取日历事件
export const queryCalendarEventList = (params: EventRequest) => {
  return get<PaginationResponse<CalendarEvent>>('/authenti-guard/v1/api/calendar/list', params)
}

// 获取品牌活动
export const getBrandEvents = (eventId: number) => {
  return get<CalendarEvent[]>(`/authenti-guard/v1/api/calendar/${eventId}`)
}

/**
 * 获取活动标签列表
 */
export const queryEventTagList = (params: PaginationParams) => {
  return get<PaginationResponse<EventTag>>('/authenti-guard/v1/api/tag/list', params)
}
